import { z } from 'zod';

export const CHAT_SETTINGS_TABS = [
  'appearance',
  'hours',
  'forms',
  'consent',
  'behaviour',
  'shortcuts',
  'departments',
  'triggers',
  'bans',
] as const;

export type ChatSettingsTab = (typeof CHAT_SETTINGS_TABS)[number];

/** Tabs whose content is a `settings.chat` form; they stay mounted so unsaved edits survive. */
export const FORM_TABS: readonly ChatSettingsTab[] = [
  'appearance',
  'hours',
  'forms',
  'consent',
  'behaviour',
];

/** `?tab=` on the chat settings page; anything else opens Appearance. */
export const chatSettingsSearchSchema = z.object({
  tab: z.enum(CHAT_SETTINGS_TABS).optional().catch(undefined),
});

export type ChatSettingsSearch = z.infer<typeof chatSettingsSearchSchema>;
